// AreaAluno.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { FaFile, FaFolder, FaFolderOpen } from "react-icons/fa";
import { Collapse, Dropdown, Icon, Menu, Table } from "antd";

import { montarIcon } from "../../../shared/utils/Drive/file/getFileIcon";
import { montarTipoPartilha } from "../../../shared/utils/Drive/share/getShareType";
import { montarBotaoDescarregar } from "../../../shared/utils/Drive/button/MontarBotaoDescarregar";
import { downloadFile } from "../../../shared/utils/fileDownloader";

import { noimage } from "../../../assets";

import "moment/locale/pt";

const { Panel } = Collapse;

export default function DriveDisciplina({
    pastas,
    ficheiros,
    acesso,
    context,
    adicionarPasta,
    adicionarFicheiro,
    excluirPasta,
    editarPasta,
    carregarDetalhe,
    abrirMoverFicheiros,
    excluir,
    abrirDetalhe,
    pastaAtual,
    handlerPastaAtual
}) {
    moment.locale("pt");

    const [dataSource, setDataSource] = useState([]);
    const [breadcrumb, setBreadcrumb] = useState([]);

    const MontarBotoesPasta = pasta => {
        return (
            pasta.pasta_dinamica === false && (
                <div className="pasta-controlos">
                    {pasta.autor && !context.fechado && acesso?.update && (
                        <>
                            <Link
                                className="botao-icon-editar"
                                to="#"
                                title="Editar"
                                onClick={e => {
                                    editarPasta(pasta.id);
                                    e.stopPropagation();
                                }}
                            >
                                <Icon type="edit" />
                            </Link>
                        </>
                    )}
                    {acesso?.delete && (
                        <Link
                            className="botao-icon-excluir"
                            to="#"
                            title="Excluir"
                            onClick={e => {
                                excluirPasta(pasta.id);
                                e.stopPropagation();
                            }}
                        >
                            <Icon type="delete" />
                        </Link>
                    )}
                </div>
            )
        );
    };

    const MontarBotoesFicheiro = documento => {
        return (
            <span className="pasta-controlos">
                {documento.proprio && !context.fechado ? (
                    <>
                        {acesso?.read && montarBotaoDescarregar(documento)}
                        {documento.ficheiro_dinamico === false && (
                            <>
                                {acesso?.update && (
                                    <>
                                        <Link
                                            className="botao-icon-editar"
                                            to="#"
                                            onClick={() => carregarDetalhe(documento.id)}
                                            title="Editar"
                                        >
                                            <Icon type="edit" />
                                        </Link>
                                        <Link
                                            className="botao-icon-mover"
                                            to="#"
                                            onClick={() => abrirMoverFicheiros(documento.id)}
                                            title="Mover"
                                        >
                                            <Icon type="drag" />
                                        </Link>
                                    </>
                                )}
                                {acesso?.delete && (
                                    <Link className="botao-icon-excluir" to="#" onClick={() => excluir(documento.id)} title="Excluir">
                                        <Icon type="delete" />
                                    </Link>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        {acesso?.read && montarBotaoDescarregar(documento)}
                        {documento.ficheiro_dinamico === false && (
                            <>
                                {acesso?.update && (
                                    <Link
                                        className="botao-icon-mover"
                                        to="#"
                                        onClick={() => abrirMoverFicheiros(documento.id)}
                                        title="Mover"
                                    >
                                        <Icon type="drag" />
                                    </Link>
                                )}
                                {acesso?.delete && (
                                    <Link className="botao-icon-excluir" to="#" onClick={() => excluir(documento.id)} title="Excluir">
                                        <Icon type="delete" />
                                    </Link>
                                )}
                            </>
                        )}
                    </>
                )}
            </span>
        );
    };
    
    const montarFicheirosMobile = documento => {
        return (
            <Dropdown overlay={opcoesMobile(documento)} placement="bottomLeft" trigger={["click"]}>
                <a className="botao-icon-configs" onClick={e => e.preventDefault()}>
                    <i className="fas fa-cog" />
                </a>
            </Dropdown>
        );
    };
    const opcoesPastaMobile = pasta => {
        return (
            <Menu>
                {pasta.autor && !context.fechado && acesso?.update && (
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={e => {
                                editarPasta(pasta.id);
                                e.stopPropagation();
                            }}
                        >
                            Editar
                        </Link>
                    </Menu.Item>
                )}
                {acesso?.delete && (
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={e => {
                                excluirPasta(pasta.id);
                                e.stopPropagation();
                            }}
                        >
                            Excluir
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };
    const opcoesMobile = documento => {
        if (documento.proprio && !context.fechado)
            return (
                <Menu>
                    {!documento.link && !documento.editor && (
                        <Menu.Item>
                            <Link to="#" onClick={() => downloadFile(documento.nome, documento.ficheiro)}>
                                Descarregar
                            </Link>
                        </Menu.Item>
                    )}
                    {documento.editor && acesso?.read && (
                        <Menu.Item>
                            <Link
                                to={`/turma-player/${this.props.match.params.turma
                                    .replace(/[&\/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                                    .toLowerCase()}/${documento.nome
                                    .replace(/[&\/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                                    .toLowerCase()}/player-ficheiro`}
                                onClick={() => localStorage.setItem("codigo_documento", documento.id)}
                            >
                                Acessar
                            </Link>
                        </Menu.Item>
                    )}
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() =>
                                abrirDetalhe(
                                    montarAutor(documento),
                                    (!documento.todos || (documento.todos && documento.totalParticipantes > 0)) &&
                                        montarTipoPartilha(documento)
                                )
                            }
                        >
                            Detalhe
                        </Link>
                    </Menu.Item>
                    {acesso?.update && (
                        <Menu.Item>
                            <Link to="#" onClick={() => carregarDetalhe(documento.id)}>
                                Editar
                            </Link>
                        </Menu.Item>
                    )}
                    {acesso?.update && (
                        <Menu.Item>
                            <Link to="#" onClick={() => abrirMoverFicheiros(documento.id)}>
                                Mover
                            </Link>
                        </Menu.Item>
                    )}
                    {acesso?.delete && (
                        <Menu.Item>
                            <Link to="#" onClick={() => excluir(documento.id)}>
                                Excluir
                            </Link>
                        </Menu.Item>
                    )}
                </Menu>
            );
        else
            return (
                <Menu>
                    {!documento.link && !documento.editor && (
                        <Menu.Item>
                            <Link to="#" onClick={() => downloadFile(documento.nome, documento.ficheiro)}>
                                Descarregar
                            </Link>
                        </Menu.Item>
                    )}
                    {documento.link && acesso?.read && (
                        <Menu.Item>
                            <a href={documento.ficheiro} target="_blank" rel="noopener noreferrer">
                                Acessar
                            </a>
                        </Menu.Item>
                    )}
                    {documento.editor && acesso?.read && (
                        <Menu.Item>
                            <Link
                                to={`/turma-player/${this.props.match.params.turma
                                    .replace(/[&\/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                                    .toLowerCase()}/${documento.nome
                                    .replace(/[&\/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                                    .toLowerCase()}/player-ficheiro`}
                                onClick={() => localStorage.setItem("codigo_documento", documento.id)}
                            >
                                Acessar
                            </Link>
                        </Menu.Item>
                    )}
                    {!context.fechado && acesso?.read && (
                        <Menu.Item>
                            <Link to="#" onClick={() => this.excluir(documento.id)}>
                                Excluir
                            </Link>
                        </Menu.Item>
                    )}
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() =>
                                abrirDetalhe(
                                    documento.autor,
                                    (!documento.todos || (documento.todos && documento.totalParticipantes > 0)) &&
                                        montarTipoPartilha(documento)
                                )
                            }
                        >
                            Detalhe
                        </Link>
                    </Menu.Item>
                </Menu>
            );
    };
    const montarPastasMobile = pasta => {
        return (
            pasta.pasta_dinamica === false && (
                <Dropdown overlay={opcoesPastaMobile(pasta)} onClick={e => e.stopPropagation()} placement="bottomLeft">
                    <Link to="#" className="botao-icon-configs">
                        <i className="fas fa-cog" />
                    </Link>
                </Dropdown>
            )
        );
    };
    const montarAutor = documento => {
        return (
            <div className="info-autor">
                <div className="container-img">
                    <img src={documento.autor.foto ? documento.autor.foto : noimage} />
                </div>
                <div className="info">
                    <span className="nome">
                        {documento.autor.nome_completo.split(" ").length > 1
                            ? `${documento.autor.nome_completo.split(" ")[0]} ${
                                  documento.autor.nome_completo.split(" ")[documento.autor.nome_completo.split(" ").length - 1]
                              }`
                            : documento.autor.nome_completo}
                    </span>
                    <p className="numero">{documento.autor.numero}</p>
                </div>
            </div>
        );
    };

    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => {
                if (record.tipo === "pasta") {
                    return (
                        <span onClick={() => handlePastaAtualId(record.id)} className="nome-ficheiro-icon">
                            <FaFolderOpen size={20} color={"#f5ca5a"} /> {text}
                        </span>
                    );
                }
                return (
                    <a
                        style={{ color: "rgba(0,0,0,0.65)" }}
                        className="nome-ficheiro-icon"
                        href={record.ficheiro}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                    >
                        {montarIcon(record)} {text}
                    </a>
                );
            }
        },
        {
            title: "Modificado",
            dataIndex: "dt_criado",
            render: (text, record) => (text ? moment(record.dt_criado).format("DD/MM/YYYY") : "-")
        },

        {
            title: "Autor",
            dataIndex: "autor",
            key: (text, record) => {
                return record.id;
            },
            render: (text, documento) => {
                if (documento.tipo === "pasta") {
                    return "-";
                }
                return montarAutor(documento);
            }
        },
        {
            title: "Partilha",
            dataIndex: "autor",
            render: (text, record) => {
                if (record.tipo === "pasta") {
                    return "-";
                }
                return montarTipoPartilha(record);
            }
        },
        {
            title: "",
            dataIndex: "",
            render: (text, record) => {
                if (record.tipo !== "pasta") {
                    return MontarBotoesFicheiro(record);
                }
                return MontarBotoesPasta(record);
            }
        }
    ];

    const columnsMobile = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => {
                if (record.tipo === "pasta") {
                    return (
                        <span onClick={() => handlePastaAtualId(record.id)} className="nome-ficheiro-icon">
                            <FaFolderOpen size={20} color={"#f5ca5a"} /> {text}
                        </span>
                    );
                }
                return (
                    <a
                        style={{ color: "rgba(0,0,0,0.65)" }}
                        className="nome-ficheiro-icon"
                        href={record.ficheiro}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                    >
                        {montarIcon(record)} {text}
                    </a>
                );
            }
        },
        {
            title: "",
            dataIndex: "",
            render: (text, record) => {
                if (record.tipo !== "pasta") {
                    return <div className={"pasta-controlos"}>{montarFicheirosMobile(record)}</div>;
                }
                return <div className={"pasta-controlos"}>{montarPastasMobile(record)}</div>;
            }
        }
    ];

    const handlePastaAtualId = id => {
        if (id === null) {
            let subPastas = pastas
                .filter(p => p.nivel === 1)
                .map(p => ({
                    ...p,
                    tipo: "pasta"
                }));

            setDataSource([...subPastas, ...ficheiros]);
            setBreadcrumb([{ id: null, nome: "Todos Ficheiros" }]);
            handlerPastaAtual(null);
            return;
        }

        const pastasMostrar = pastas
            .filter(f => f.pastaPai === id)
            .map(f => ({
                ...f,
                tipo: "pasta"
            }));

        const pastaAtual = pastas.find(f => f.id === id);

        handlerPastaAtual(pastaAtual);

        const ficheirosDaPastaAtual = (pastaAtual?.ficheiros || []).map(f => {
            return { ...f, tipo: "ficheiro" };
        });

        setDataSource([...pastasMostrar, ...ficheirosDaPastaAtual]);

        if (pastaAtual?.niveis) {
            const caminho = pastaAtual.niveis
                .split(".")
                .map(n => parseInt(n))
                .map(nivelId => {
                    const pasta = pastas.find(p => p.id === nivelId);
                    return pasta ? { id: pasta.id, nome: pasta.nome } : null;
                })
                .filter(Boolean);

            caminho.unshift({ id: null, nome: "Todos Ficheiros" });
            // guarda no state se quiseres usar no UI
            setBreadcrumb(caminho);
        }
    };

    useEffect(() => {
        if (pastaAtual) {
            handlePastaAtualId(pastaAtual?.id);
        } else {
            handlePastaAtualId(null);
        }
    }, [pastas, ficheiros]);

    return (
        <div className="area-drive">
            <div className="breadcrumb">
                {breadcrumb.map((item, index) => (
                    <span key={item.id}>
                        <span style={{ cursor: "pointer", fontWeight: "bold" }} onClick={() => handlePastaAtualId(item.id)}>
                            {item.nome}
                        </span>

                        {index < breadcrumb.length - 1 && " / "}
                    </span>
                ))}
            </div>
            <>
                <div className="desktop-only">{dataSource && <Table className="tabela" dataSource={dataSource} columns={columns} />}</div>
                <div className="mobile-only">
                    {dataSource && <Table className="tabela" dataSource={dataSource} columns={columnsMobile} />}
                </div>
            </>
        </div>
    );
}
